/* Single – bundler voor modules in deze map
   Volgorde:
   1) variationUI  → bouwt UI bovenop selects
   2) priceTotal   → luistert naar Woo events en berekent totaal
   3) qtySteppers  → ± knoppen en total herberekenen
   4) checklist    → extra's spiegelen naar hoofdformulier
   5) stickyAtc    → plakt aan priceTotal (leest daar de prijs uit)
   6) gallery      → eenvoudige thumb → stage swap
*/
import { mount as mountUI }          from './variationUI.js';
import { mount as mountMatrix }      from './groupedMatrix.js';
import { mount as mountPriceTotal }  from './priceTotal.js';
import { mount as mountQty }         from './qtySteppers.js';
import { mount as mountChecklist }   from './checklistBridge.js';
import { mount as mountStickyAtc }   from './stickyAtc.js';
import { mount as mountGallery }     from './gallery.js';

export function mount() {
  // idempotente mounts (elke module heeft zelf een guard waar nodig)
  mountUI?.();
  mountMatrix?.();
  mountPriceTotal?.();
  mountQty?.();
  mountChecklist?.();
  mountStickyAtc?.();
  mountGallery?.();
}
